import { useTranslation } from 'react-i18next';

import { Card, CardContent, Typography } from '@mui/joy';

import { formatBytes} from '../../general-utilities/heartbeatUtils';
import { DroneHeartBeat } from '../../models/DroneProfile/DroneProfile.model';

interface Props {
  heartbeat: DroneHeartBeat;
}

export default function DiskIOCard({ heartbeat}: Props) {
  const { t } = useTranslation();
  const io = heartbeat.disk_io;

  return (
    <Card color="neutral" variant="soft">
      <CardContent>
        <Typography gutterBottom level="title-md">
          {t('heartbeat.io_stats.disk_title')}
        </Typography>

        {io ? (
          <div className="space-y-3 mt-3">
            <div className="flex justify-between text-sm text-gray-600">
              <span>{t('heartbeat.io_stats.read')}:</span>
              <span className="font-medium">{formatBytes(io.read_bytes)}</span>
            </div>
            <div className="flex justify-between text-sm text-gray-600">
              <span>{t('heartbeat.io_stats.write')}:</span>
              <span className="font-medium">{formatBytes(io.write_bytes)}</span>
            </div>
          </div>
        ) : (
          <p className="text-sm text-center text-gray-500 mt-2">
            {t('heartbeat.io_stats.no_disk_info')}
          </p>
        )}
      </CardContent>
    </Card>
  );
}
